import { apiRestClient } from '@Lib/http/restClient';
import { AuthSession } from '@Shared/auth/auth-session';

export interface MeResponse {
  payroll: string;
  basicInformation: {
    name: string;
    lastNames: {
      first: string;
      second: string;
      full: string;
    };
    phoneNumber: string;
    email: string;
    residence: string;
    status: string;
    photo?: string;
  };
  professionalInfo: {
    currentFleet: string;
    lastFleet: string;
    contractType: {
      value: string;
      desc: string;
    };
    seniority: string;
    supervisor: string;
    pickupService: boolean;
    jobRole: {
      value: string;
      desc: string;
      groupCode: string;
    };
    category: string;
  };
}

export async function getMe(employeeId?: string): Promise<MeResponse> {
  const id = employeeId ?? AuthSession.getInstance().getIdTokenClaims()?.employeeid;
  const url = id ? `v1/me?userId=${id}` : 'v1/me';
  const response = await apiRestClient.get<MeResponse>(url);

  if (!response.ok) {
    throw new Error(`Error ${response.status} al obtener el perfil`);
  }

  return response.data;
}

export async function getMeByPayroll(payrollNumber: string): Promise<MeResponse> {
  const response = await apiRestClient.get<MeResponse>(`v1/me?userId=${payrollNumber}`);

  if (!response.ok) {
    throw new Error(`Error ${response.status} al obtener el perfil del usuario`);
  }

  return response.data;
}
